<template>
  <fieldset class="radio-inline" data-test-base-radio-images>
    <div class="row">
      <div v-for="option in options" :key="option.id" class="columns medium-6 small-12">
        <base-radio-image
          :model-value="modelValue"
          :name="name"
          :data="option"
          @update:model-value="$emit('update:modelValue', modelValue)"
          :meta="meta"
        />
      </div>
    </div>
  </fieldset>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import BaseRadioImage from '../BaseRadioImage/BaseRadioImage.vue';
import BaseRadioImageOption from '../BaseRadioImage/interfaces/BaseRadioImageOption';

export default defineComponent({
  name: 'BaseRadioImages',
  emits:['update:modelValue'],
  components: { BaseRadioImage },
  props: {
    name: {
      type: String,
      default() {
        return 'base-radio-images';
      }
    },
    options: {
      type: Array as PropType<BaseRadioImageOption[]>,
      default() {
        return [];
      }
    },
    meta: {
      type: Object,
      default() {
        return {};
      }
    },
    modelValue: {
      type: [ Object, String ],
      default() {
        return null;
      }
    }
  }
});
</script>
